export default __webpack_public_path__ + "static/media/texas.847edac0.svg";